<!--我的招标-->
<template>
  <div class="mine-bidding-container">
    <headerIndex/>
    <!--面包削-切换导航栏-->
    <div class="bidding-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/outsourceDemand/index' }">交易大厅</el-breadcrumb-item>
        <el-breadcrumb-item>我的招标</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!--正文内容-->
    <div class="mine-bidding-content">
      <el-row :gutter="16">
        <el-col :span="18">
          <div class="left-bidding">
            <div class="left-top-search">
              <el-dropdown @command="checkScreen" trigger="click" style="padding-right: 20px;">
                <span class="el-dropdown-link">
                  {{ sortType }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="-2" :class="sortType=='全部' ? 'isActive' : ''">
                    <span>全部</span>
                  </el-dropdown-item>
                  <el-dropdown-item v-for="item in tenderOptions" :command="item" :class="tenderStatus==item.value ? 'isActive' : ''">
                    <span>{{ item.name }}</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="bidding-list" v-if="biddingInfo.length>0" :style="'min-height:'+min_height+'px;'">
              <el-row :gutter="16">
                <el-col :span="12" v-for="(bid,idnex) of biddingInfo" class="el-bid-list" style="padding: 0px 15px;">
                  <div class="grid-content bg-purple" :ref="'bid'+idnex" @click="biddingDetails(bid)">
                    <div class="bid-status">
                      <div class="bid-left-status">
                        <i class="tag-1">
                          <span class="tag-red">招投标</span>
                          <span class="tag-white">{{ bid.money }}{{ bid.moneyUnit }}</span>
                        </i>
                        <i class="tag-2" v-if="bid.urgent==1">急</i>
                        <i class="tag-2" v-if="bid.top==1">置顶</i>
                      </div>
                      <div class="bid-right-status">
                        <!--状态（-1：审核不通过0：审核中，
                              1：公示中（招标时间未开始），
                              2：招标中（招标时间内），
                              3：招标成功（约请合作），
                              4：待选标（招标时间截止7天内，有投标报名，但还未选标），
                              5：选标失败（招标时间截止7天后，有投标报名，但未进行选标），
                              6：流标（招标时间截止，没有投标报名））
                              -->
                        <i class="status-1" v-if="bid.status==1"/>
                        <!--<i class="status-2" v-if="bid.status==2"/>-->
                        <i class="status-2" v-if="bid.status==4"/>
                        <i class="status-3" v-if="bid.status==3"/>
                        <i class="status-4" v-if="bid.status==5"/>
                        <i class="status-5" v-if="bid.status==6"/>
                      </div>
                    </div>
                    <p class="small-title SourceHanSansCN">{{ bid.title }}</p>
                    <p class="bottom-p">
                      <span class="left-span"><i class="iconfont icon-clock"/>{{ bid.statusFormat }}</span>
                      <span class="right-span"><i class="iconfont icon-user"/>{{ bid.nums }}人报名</span>
                    </p>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="bidding-list" v-else :style="'min-height:'+min_height+'px;'">
              <el-empty description="暂无内容"/>
            </div>
          </div>
          <!-- 分页 -->
          <page :total="tablePage.total" class="pagination" @currentPage="currentPage"
                :page="tablePage.currentPage" :limit="tablePage.pageSize" style="padding: 10px 20px 10px 0px;"/>
        </el-col>
        <el-col :span="6">
          <div class="bidding-demand" @click="releaseDemand"></div>
        </el-col>
      </el-row>
    </div>
    <Hang/>
    <home_footer/>
    <el-dialog title="提示" :visible.sync="dialogVisible2" width="20%" class="dialog">
      <p>您还未认证企业，暂无法发布需求。</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="certifiedEnterprise">认证企业</el-button>
         <el-button @click="dialogVisible2=false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import page from "@/components/page/pages";
import {
  tenderStatusList,
  myTenderList,
} from '@/api/cloudServiceApi'

export default {
  name: "mineBidding",
  components: {headerIndex, Hang, home_footer,page},
  data() {
    return {
      cid: 0,
      tenderOptions: [],
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      sortType: '招标状态',
      tenderStatus: null,
      personalInfo: {},
      biddingInfo:[],
      min_height: document.documentElement.clientHeight - 504,
      dialogVisible2: false,
    }
  },
  methods: {
    /*获取我的招标信息*/
    getMineBiddingInfo() {
      myTenderList({
        bid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        page: this.tablePage.currentPage,
        pageLimit: this.tablePage.pageSize,
        status: this.tenderStatus,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then(res => {
        if (res.code==200){
          this.biddingInfo=res.content.rows;
          this.tablePage.total=res.content.total;
        }
      })
    },
    /*招标状态/截止时间 列表*/
    getTenderStatusList() {
      tenderStatusList({type: 3, uid: this.cid != 0 && this.cid != undefined ? this.cid : 0}).then(res => {
        if (res.code == 200) {
          this.tenderOptions = res.content;
        }
      })
    },
    /*发布需求*/
    releaseDemand() {
      /**
       * @param verified_type 认证类型（1：个人，2：政府，3：企业，4：媒体，5：其他）
       * @param state 认证状态（1：已认证。0未认证,2:审核中，-1：认证失败）
       */
      if (this.personalInfo.verified_type == 3 && this.personalInfo.state == 1) {
        this.$router.push({path: '/outsourceDemand/releaseDemand',})
      } else {
        this.dialogVisible2 = true;
      }
    },
    /*切换招标状态调用查询接口*/
    checkScreen(row){
      if (row==-2){
        this.sortType = '全部';
        this.tenderStatus = null;
        this.tablePage.currentPage = 1;
      }else{
        if (this.tenderStatus != row.value) {
          this.sortType = row.name;
          this.tenderStatus = row.value;
          this.tablePage.currentPage = 1;
        }
      }
      this.getMineBiddingInfo();
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getMineBiddingInfo();
    },
    /*招标详情*/
    biddingDetails(demand) {
      this.$router.push({
        path: '/outsourceDemand/biddingDetails',
        query: {
          id:demand.zid,
          from:1,
        }
      })
    },
    /*认证企业*/
    certifiedEnterprise() {
      let routeData = this.$router.resolve({
        name: "enterpriseCertification",
        path: '/officialCloud/enterpriseCertification',
      });
      window.open(routeData.href, '_blank')
    },
  },
  mounted() {
    this.getTenderStatusList();
    this.getMineBiddingInfo();

  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.personalInfo = sessionStorage.getItem('personalInfo') != null && sessionStorage.getItem('personalInfo') != undefined && sessionStorage.getItem('personalInfo') != '' ? JSON.parse(sessionStorage.getItem('personalInfo')) : '';
  }
}
</script>
<style scoped>
.mine-bidding-container >>> .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-weight: bold;
  color: #5D5D5D;
}

.mine-bidding-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.mine-bidding-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.mine-bidding-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.mine-bidding-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #5D5D5D;
  font-family: 'SourceHanSansCN';
}
</style>
<style scoped lang="scss">
.mine-bidding-container {
  background: #F5F5F5;

  .bidding-breadcrumb {
    padding: 20px 18%;
    min-width: 76rem;
    background: #F5F5F5;
  }

  .mine-bidding-content {
    margin: 0px 18% 30px;
    min-width: 76rem;
    background: #F5F5F5;
    padding-right: 18%;
    .left-bidding {
      background: #ffffff;
      .left-top-search {
        border: 1px solid #EDEDED;
        padding: 20px 40px;
      }
      .bidding-list{
        padding: 30px 30px 20px;
        border: 1px solid #EDEDED;
        border-top: none;
        .el-bid-list {
          margin-bottom: 20px;
          .bg-purple {
            background: #F3F9FF;
            border-radius: 8px;
            padding: 30px 20px;
            .bid-status{
              display: flex;
              justify-content: space-between;
              .bid-left-status{
                .tag-1 {
                  font-style: normal;
                  cursor: pointer;
                  .tag-red {
                    padding: 10px;
                    color: #ffffff;
                    background: #FE273B;
                    font-size: 14px;
                    border-radius: 6px 0px 0px 6px;
                    border: 1px solid #FE273B;
                  }
                  .tag-white {
                    padding: 10px;
                    color: #FE273B;
                    background: white;
                    font-size: 14px;
                    border: 1px solid #FE273B;
                    border-radius: 0px 6px 6px 0px;
                  }
                }
                .tag-2 {
                  font-style: normal;
                  color: #FE273B;
                  border-radius: 6px;
                  border: 1px solid #FE273B;
                  padding: 10px;
                  margin-left: 20px;
                  font-size: 14px;
                  cursor: pointer;
                }
              }
              .bid-right-status{
                height: 76px;
                width: 94px;
                margin-top: -45px;
                position: absolute;
                margin-left: 36%;
                .status-1{
                  width: 94px;
                  height: 76px;
                  background: url("~@/assets/img/cloud/under_publicity.png");
                  background-size: 100% 100%;
                  position: absolute;
                }
                .status-2{
                  width: 94px;
                  height: 76px;
                  background: url("~@/assets/img/cloud/bidToSelected.png");
                  background-size: 100% 100%;
                  position: absolute;
                }
                .status-3{
                  width: 94px;
                  height: 76px;
                  background: url("~@/assets/img/cloud/bidding_success.png");
                  background-size: 100% 100%;
                  position: absolute;
                }
                .status-4{
                  width: 94px;
                  height: 76px;
                  background: url("~@/assets/img/cloud/biddingToError.png");
                  background-size: 100% 100%;
                  position: absolute;
                }
                .status-5{
                  width: 94px;
                  height: 76px;
                  background: url("~@/assets/img/cloud/failToSoldAuction.png");
                  background-size: 100% 100%;
                  position: absolute;
                }
              }
            }
            .small-title {
              color: #333333;
              font-size: 18px;
              text-align: left;
              cursor: context-menu;
              margin-block-end: 0em;
              padding-top: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              word-wrap: break-word;
              word-break: break-all;
              .user-name {
                font-size: 16px;
                color: #333333;
              }
              .el-position {
                font-style: normal;
                font-size: 12px;
                color: #ffffff;
                background: #FF9600;
                padding: 3px 5px;
                border-radius: 4px;
                margin-left: 10px;
              }
              .right-icon {
                float: right;
                width: 30px;
                height: 30px;
                .icon-phone {
                  background: url("~@/assets/img/cloud/dianhua.png");
                  width: 30px;
                  height: 30px;
                  background-size: 100% 100%;
                  position: absolute;
                  cursor: pointer;
                }
              }
            }
            .gray-p {
              color: #999999;
              font-size: 14px;
            }
            .bottom-p {
              margin-block-start: 0em;
              margin-block-end: 0em;
              padding-top: 10px;
              .left-span {
                color: #666666;
                font-size: 14px;
              }
              .right-span {
                color: #666666;
                font-size: 14px;
                float: right;
              }
              .iconfont {
                color: #333333;
              }
            }
          }
        }
      }
    }

    .bidding-demand {
      background: url("~@/assets/img/cloud/releaseDemand.png") no-repeat;
      background-size: 100% 100%;
      height: 196px;
      cursor: pointer;
    }
  }
}
</style>
<style>
.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #FE273B;
  font-weight: normal;
}

.isActive {
  color: #FE273B;
}
</style>